import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { ConnectionIntegrationType } from '../connection-integration-types'

export const ConnectionMercadoPago = ({
  hasSelectFocus,
  renderPaymentMethodType,
  connectionResponse,
  handleFocus,
  handleChangePayment,
  paymentMethods,
  renderIntegrationType,
  handleChangeIntegration,
  integrationTypes,
  formData,
}) => {
  const {
    getValues,
  } = useFormContext()

  const [country, setCountry] = useState()
  const [integrationTypesMP, setIntegrationTypesMP] = useState([])

  useEffect(() => {
    const country = getValues('country')
    !!country && setCountry(country)
    setIntegrationTypesMP(integrationTypes)
  }, [getValues('country')])

  useEffect(() => {
    if (country !== 'CO') {
      const integrationsFiltered = integrationTypesMP?.filter(
        (integration) => integration.id !== 'MERCADO_PAGO_CHECKOUT_API_APM',
      )
      setIntegrationTypesMP(integrationsFiltered)
    }
  }, [country])

  return (
    <>
      {country && (
        <ConnectionIntegrationType
          hasSelectFocus={hasSelectFocus}
          renderIntegrationType={renderIntegrationType}
          connectionResponse={connectionResponse}
          handleFocus={handleFocus}
          handleChangeIntegration={handleChangeIntegration}
          integrationTypes={integrationTypesMP}
          renderPaymentMethodType={renderPaymentMethodType}
          handleChangePayment={handleChangePayment}
          formData={formData}
          paymentMethods={paymentMethods}
        />
      )}
    </>
  )
}
